import {trace, context, SpanStatusCode} from '@opentelemetry/api';

/**
 * Create an axios response interceptor that sets span status based on HTTP status
 * To be used with axios interceptors
 *
 * @return {Array} An array of [success, error] interceptors
 */
export function createSpanStatusInterceptors() {
  // On successful response
  const onSuccess = response => {
    const currentSpan = trace.getSpan(context.active());
    if (currentSpan) {
      // Set HTTP status code
      currentSpan.setAttribute('http.status_code', response.status);

      // Set status based on HTTP status code
      if (response.status >= 200 && response.status < 400) {
        currentSpan.setStatus({code: SpanStatusCode.OK});
      } else {
        currentSpan.setStatus({
          code: SpanStatusCode.ERROR,
          message: `HTTP ${response.status}`,
        });
      }
    }
    return response;
  };

  return [onSuccess];
}
